import { selectActiveFeature } from './selectActiveFeature';
import { IApplicationState } from '../../../common/types/redux';
import { PIN_COUNTER_MIN_COUNT } from '../../../common/utils/ymapsModules/BalloonManager/getPinCounterLabel';

/**
 * Выбран мультипин - порог тот же, что у каунтера пина.
 * Как его показать, решает платформа: десктоп - балун со стрелками, телефон - шторка со всеми объявлениями.
 */
export const selectIsMultipinSelected = (state: IApplicationState): boolean =>
  (selectActiveFeature(state)?.properties.offersCount ?? 0) >= PIN_COUNTER_MIN_COUNT;
